import { applicationSettings } from '../settings/application';
export default {
  isKiosk: applicationSettings.uiPlatform === 'kiosk',
};
